import React from "react";
import { HiOutlineBars3 } from "react-icons/hi2";
import User from "./user-dropdown/UserDropdown";
import NotificationDropdown from "./notification/notificationDropdown";

const Header = ({ toggleMenuSidebar }) => {
  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      <ul className="navbar-nav">
        <li className="nav-item">
          <button
            onClick={toggleMenuSidebar}
            type="button"
            className="flex h-10 w-10 items-center justify-center rounded-md bg-admin-primary hover:bg-admin-primary-hover border-none "
          >
            <HiOutlineBars3 className="h-8 w-8 md:h-7 md:w-7 text-white" />
          </button>
        </li>
      </ul>

      <ul className="navbar-nav ml-auto align-items-center">
        {localStorage.getItem("is_admin") === "false" && (
          <NotificationDropdown />
        )}
        <User />
      </ul>
    </nav>
  );
};

export default Header;
